import { useState } from "react";
import API from "../../../services/api";

import "./TermsConditionsStep.css";
import LegalModal from "../LegalModal/LegalModal";

function TermsConditionsStep({
    providerData,
    previousStep,
    nextStep,
}) {

    const [loading, setLoading] = useState(false);

    const [agree, setAgree] = useState({
        declaration: false,
        terms: false,
        privacy: false,
        provider: false,
        payout: false,
    });

    const [openModal, setOpenModal] = useState(false);

    const [modalTitle, setModalTitle] = useState("");

    const [modalContent, setModalContent] = useState(null);

    const handleCheck = (field) => {

        setAgree((prev) => ({
            ...prev,
            [field]: !prev[field],
        }));

    };

    const allAccepted =
        agree.declaration &&
        agree.terms &&
        agree.privacy &&
        agree.provider &&
        agree.payout;

    const openLegal = (type) => {

        switch (type) {

            case "terms":

                setModalTitle("HomeFoods Terms of Service");

                setModalContent(
                    <>
                        <h3>1. Eligibility</h3>

                        <p>
                            Providers must submit genuine business
                            information.
                        </p>

                        <h3>2. Food Safety</h3>

                        <p>
                            Every food item should be prepared hygienically
                            and according to FSSAI guidelines.
                        </p>

                        <h3>3. Account Suspension</h3>

                        <p>
                            HomeFoods reserves the right to suspend any
                            provider violating platform policies.
                        </p>
                    </>
                );

                break;

            case "privacy":

                setModalTitle("Privacy Policy");

                setModalContent(
                    <>
                        <p>
                            Your personal, business and banking
                            information is securely stored and used only
                            for HomeFoods services.
                        </p>
                    </>
                );

                break;

            case "provider":

                setModalTitle("Provider Guidelines");

                setModalContent(
                    <>
                        <ul>

                            <li>Maintain food hygiene.</li>

                            <li>Use fresh ingredients.</li>

                            <li>Accept orders responsibly.</li>

                            <li>Maintain quality packaging.</li>

                            <li>Follow delivery timings.</li>

                        </ul>
                    </>
                );

                break;

            case "payout":

                setModalTitle("Payout Policy");

                setModalContent(
                    <>
                        <p>
                            Provider earnings are transferred according
                            to HomeFoods payout schedule after successful
                            order completion.
                        </p>
                    </>
                );

                break;

            default:
                return;
        }

        setOpenModal(true);

    };
    // =======================================================
// Submit Provider Application
// =======================================================

const handleSubmit = async () => {

    if (!allAccepted) {

        alert("Please accept all Terms & Conditions.");

        return;

    }

    try {

        setLoading(true);

        const formData = new FormData();

        // ==========================================
        // Owner Details
        // ==========================================

        formData.append(
            "ownerName",
            providerData.owner.name
        );

        formData.append(
            "phone",
            providerData.owner.phone
        );

        formData.append(
            "email",
            providerData.owner.email
        );

        formData.append(
            "gender",
            providerData.owner.gender || ""
        );

        // ==========================================
        // Provider Type
        // ==========================================

        formData.append(
            "providerType",
            providerData.providerType
        );

        // ==========================================
        // Business
        // ==========================================

        formData.append(
            "business",
            JSON.stringify(providerData.business)
        );

        // ==========================================
        // Address
        // ==========================================

        formData.append(
            "address",
            JSON.stringify(providerData.address)
        );

        // ==========================================
        // Bank Details
        // ==========================================

        formData.append(
            "bankDetails",
            JSON.stringify(providerData.bank)
        );

        // ==========================================
        // Upload Photos
        // ==========================================

        if (providerData.photos?.profilePhoto) {

            formData.append(
                "profilePhoto",
                providerData.photos.profilePhoto
            );

        }

        if (providerData.photos?.businessPhoto) {

            formData.append(
                "businessPhoto",
                providerData.photos.businessPhoto
            );

        }

        if (providerData.photos?.businessLogo) {

            formData.append(
                "businessLogo",
                providerData.photos.businessLogo
            );

        }

        if (providerData.photos?.aadhaarFront) {

            formData.append(
                "aadhaarFront",
                providerData.photos.aadhaarFront
            );

        }

        if (providerData.photos?.aadhaarBack) {

            formData.append(
                "aadhaarBack",
                providerData.photos.aadhaarBack
            );

        }

        if (providerData.photos?.panCard) {

            formData.append(
                "panCard",
                providerData.photos.panCard
            );

        }

        // ==========================================
        // Submit Application
        // ==========================================

        const response = await API.post(

            "/provider/register",

            formData,

            {

                headers: {

                    "Content-Type":
                        "multipart/form-data",

                },

            }

        );

        console.log(
            "Provider Application Submitted",
            response.data
        );

        // ==========================================
        // Move to Success Screen
        // ==========================================
nextStep(response.data.provider._id);
    } catch (error) {

        console.error(error);

        alert(

            error.response?.data?.message ||

            "Unable to submit application."

        );

    } finally {

        setLoading(false);

    }

};
return (

    <div className="terms-step">

        <h2>Terms & Conditions</h2>

        <p className="terms-description">

            Please read all the agreements carefully before submitting your
            provider application.

        </p>

        <div className="agreement-list">

            <label className="agreement-item">

                <input
                    type="checkbox"
                    checked={agree.declaration}
                    onChange={() =>
                        handleCheck("declaration")
                    }
                />

                <span>

                    I certify that all information submitted is true and
                    accurate.

                </span>

            </label>

            <label className="agreement-item">

                <input
                    type="checkbox"
                    checked={agree.terms}
                    onChange={() =>
                        handleCheck("terms")
                    }
                />

                <span>

                    I agree to the HomeFoods Terms of Service.

                </span>

                <button
                    type="button"
                    className="link-btn"
                    onClick={() =>
                        openLegal("terms")
                    }
                >

                    Read

                </button>

            </label>

            <label className="agreement-item">

                <input
                    type="checkbox"
                    checked={agree.privacy}
                    onChange={() =>
                        handleCheck("privacy")
                    }
                />

                <span>

                    I agree to the Privacy Policy.

                </span>

                <button
                    type="button"
                    className="link-btn"
                    onClick={() =>
                        openLegal("privacy")
                    }
                >

                    Read

                </button>

            </label>

            <label className="agreement-item">

                <input
                    type="checkbox"
                    checked={agree.provider}
                    onChange={() =>
                        handleCheck("provider")
                    }
                />

                <span>

                    I agree to follow the Provider Guidelines.

                </span>

                <button
                    type="button"
                    className="link-btn"
                    onClick={() =>
                        openLegal("provider")
                    }
                >

                    Read

                </button>

            </label>

            <label className="agreement-item">

                <input
                    type="checkbox"
                    checked={agree.payout}
                    onChange={() =>
                        handleCheck("payout")
                    }
                />

                <span>

                    I agree to the HomeFoods Payout Policy.

                </span>

                <button
                    type="button"
                    className="link-btn"
                    onClick={() =>
                        openLegal("payout")
                    }
                >

                    Read

                </button>

            </label>

        </div>

        <div className="submit-info">

            <h4>What happens after submission?</h4>

            <ul>

                <li>
                    Your application will be reviewed by the HomeFoods
                    Admin Team.
                </li>

                <li>
                    Business and identity documents will be verified.
                </li>

                <li>
                    You may be contacted if additional information is
                    required.
                </li>

                <li>
                    After approval, you can create your Provider Password.
                </li>

                <li>
                    Once your password is created, you'll get access to
                    the Provider Dashboard.
                </li>

            </ul>

        </div>

        <div className="step-buttons">

            <button
                type="button"
                className="back-btn"
                onClick={previousStep}
                disabled={loading}
            >

                ← Back

            </button>

            <button
                type="button"
                className="submit-btn"
                disabled={!allAccepted || loading}
                onClick={handleSubmit}
            >

                {loading
                    ? "Submitting Application..."
                    : "Submit Application"}

            </button>

        </div>

        <LegalModal
            open={openModal}
            title={modalTitle}
            content={modalContent}
            onClose={() =>
                setOpenModal(false)
            }
        />

    </div>

);

}

export default TermsConditionsStep;